/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */
"use strict";

module.exports = function(config, get, post, upload) {
	return {
		list: list,
		data: data,
		session: {
			listActive: list_active,
			listHistory: list_history,
			listPending: list_pending,
			create: create_session,
			end: end_session,
			accept: accept_session
		},
		message: {
			list: list_message,
			send: send_message,
			sendFile: send_file_message,
			latestMessages: latest_messages,
			read: mark_read
		}
	};

	function list(){
		return get("/v2/livechat/list");
	}

	function data(group){
		return get("/v2/livechat/data", {
			group: group
		});
	}

	function list_active(page, group){
		return get("/v2/livechat/session/list/active", {
			page: page,
			group: group
		});
	}

	function list_history(page, group){
		return get("/v2/livechat/session/list/history", {
			page: page,
			group: group
		});
	}

	function list_pending(page, group){
		return get("/v2/livechat/session/list/pending", {
			page: page,
			group: group
		});
	}

	function create_session(group){
		return post("/v2/livechat/session/create", {
			group: group
		});
	}

	function end_session(session){
		return post("/v2/livechat/session/end", {
			session: session
		});
	}

	function accept_session(session){
		return post("/v2/livechat/session/accept", {
			session: session
		});
	}

	function list_message(session, page){
		return get("/v2/livechat/message/list", {
			session: session,
			page: page
		});
	}

	function send_message(session, content, to){
		return post("/v2/livechat/message/send", {
			session: session,
			content: content,
			to: to
		});
	}

	function send_file_message(session, file, to){
		return upload("/v2/livechat/message/send/file", {
			session: session,
			to: to
		}, "file", file);
	}

	function latest_messages(sessions){
		return get("/v2/livechat/message/latest/messages", {
			sessions: sessions
		});
	}

	function mark_read(session, to){
		return post("/v2/livechat/message/read", {
			session: session,
			to: to
		});
	}
};
